import { Box, Autocomplete, TextField } from "@mui/material";

export default function SelectInputAutoComplete({
  name,
  label,
  labelId,
  value,
  options = [],
  optionId = "Id",
  optionTitle = "Nome",
  onChange,
  error,
  helperText,
  emptyText = "Selecione um item",
  classHelp = { paddingTop: "1rem" },
  multiple = false,
  showIdWithTitle = false,
}) {
  const handleAutoCompleteChange = (event, newValue) => {
    if (multiple) {
      onChange(newValue.map((option) => String(option[optionId])));
    } else {
      onChange(newValue ? newValue[optionId] : null);
    }
  };

  return (
    <Box sx={classHelp}>
      <Autocomplete
        disablePortal
        clearOnEscape
        name={name}
        value={
          multiple
            ? options.filter((option) =>
                value.includes(String(option[optionId]))
              )
            : options.find(
                (option) => String(option[optionId]) === String(value)
              ) || null
        }
        onChange={handleAutoCompleteChange}
        options={options}
        getOptionLabel={(option) => option[optionTitle] ?? ""}
        isOptionEqualToValue={(option, value) =>
          String(option[optionId]) === String(value[optionId])
        }
        multiple={multiple}
        noOptionsText={emptyText}
        /* 🔴 CORREÇÃO AQUI */
        renderOption={(props, option) => (
          <li {...props} key={option[optionId]}>
            {showIdWithTitle
              ? `${option[optionId]} - ${option[optionTitle]}`
              : option[optionTitle]}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="filled"
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Box>

    // <Box sx={classHelp}>
    //   <Autocomplete
    //     disablePortal
    //     clearOnEscape
    //     name={name}
    //     value={
    //       multiple
    //         ? options.filter(option => value.includes(String(option[optionId])))
    //         : options.find(
    //             option => String(option[optionId]) === String(value)
    //           ) || null
    //     }
    //     onChange={handleAutoCompleteChange}
    //     options={options}
    //     getOptionLabel={option => option[optionTitle] ?? ""}
    //     isOptionEqualToValue={(option, value) =>
    //       String(option[optionId]) === String(value[optionId])
    //     }
    //     multiple={multiple}
    //     noOptionsText={emptyText}
    //     renderInput={params => (
    //       <TextField
    //         {...params}
    //         label={label}
    //         variant="filled"
    //         error={error}
    //         helperText={helperText}
    //       />
    //     )}
    //   />
    // </Box>
  );
}
